/* eslint-disable no-sequences */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
import moment from 'moment';
// import React, { Component } from 'react';
// import DataService from 'js/modules/dataservice';
// const step = window._app && window._app.page.step;

function myOnChangeCallback(response, changeTokenState, checkUpliftTokenAvailability) {
  const statusHandlers = {

    OFFER_AVAILABLE: function() {
      // Uplift Pay Monthly Offer available for this customer.
      console.log('There is an offer available for you!');
      // document.getElementById('uplift-pay-button').className = 'not-ready';
      // document.getElementById('up-pay-monthly-selector-from-pricing').style = 'display: block';
      checkUpliftTokenAvailability(false, false);
    },
    TOKEN_AVAILABLE: function() {
      // Uplift application has been completed and ready to pay in full.
      console.log('Your testing profile is correct. There is a token available!');
      checkUpliftTokenAvailability(true, false);
    },
    TOKEN_RETRIEVED: function() {
      // Uplift Payment Token successfully retrieved.
      // Uplift Payment Token successfully retrieved. 
      const token = response.token;

      changeTokenState(token);
      // process payment using token (uplift virtual card).
    },
    OFFER_UNAVAILABLE: function() {
      // Uplift Pay Monthly Offer is not available for this customer.
      console.log('Sorry! The offer is unavailable...');
      checkUpliftTokenAvailability(false, true);
      // document.getElementById('up-offer-not-available').style = 'display: block';
      // document.getElementById('up-pay-monthly-selector-from-pricing').style = 'display: none';
    },
    SERVICE_UNAVAILABLE: function() {
      // Uplift Payments Service is unavailable.
      checkUpliftTokenAvailability(false, true);
      console.log('Sorry! The Uplift service is unavailable...');
    }
  };

  statusHandlers[response.status]();
}

function _upliftCreateTravelersObject(guestsData) {
  const formatedDate = moment(guestsData.dateOfBirth).format('MM/DD/YYYY');
  const travelers = [
    {
      'id': guestsData.id,
      'first_name': guestsData.firstName,
      'last_name': guestsData.lastName,
      'date_of_birth': formatedDate // guestsData.dateOfBirth.replace(/[-]/g, '/')
    }
  ];

  guestsData.secondaryGuests.forEach((guest) => {
    const guestFormatedDate = moment(guest.dateOfBirth).format('MM/DD/YYYY');

    travelers.push({
      'id': guest.id,
      'first_name': guest.firstName,
      'last_name': guest.lastName,
      'date_of_birth': guestFormatedDate // guest.dateOfBirth.replace(/[-]/g, '/')
    });
  });

  return travelers;
}

function _upliftMoneyFormat(price) {
  const formatPrice = price.replace(/[,.]/g, '');
  const amount = parseInt(formatPrice, NaN);

  return amount;
}

function _upliftFillItineraries(flights) {
  const itinerary = [];

  flights.forEach((flight) => {
    const arrival = moment(flight.arrivalDate, 'MMM DD, YYYY').format('YYYYMMDD');
    const departure = moment(flight.departureDate, 'MMM DD, YYYY').format('YYYYMMDD');

    itinerary.push(
      {
        'departure_apc': flight.departureGateway,
        'departure_time': departure,
        'arrival_apc': flight.arrivalGateway,
        'arrival_time': arrival,
        'fare_class': flight.classOfServiceName,
        'carrier_code': flight.marketingCarrier,
      }
    );
  });

  return itinerary;
}

function _upliftCreateItinerariesObject(itineraries) {
  const leaving = itineraries[0].leaving;
  const returning = itineraries[0].returning;

  const leavingItinerary = _upliftFillItineraries(leaving);
  const returningItinerary = _upliftFillItineraries(returning);

  return leavingItinerary.concat(returningItinerary);
}

function initPayMonthly(changeTokenState, checkUpliftTokenAvailability, checkUpliftStatus) {
  window.Uplift.Payments.init({
    apiKey: 'WDhFTvgpzv4L2PAbYBubhawCubSbLzQT7u9PkvNG',
    locale: 'en-US',
    currency: 'USD',
    checkout: true, // change this to false for non-payment method
    channel: 'desktop',
    container: '#up-pay-monthly-container', // remove this for non-payment method
    onChange: response => myOnChangeCallback(response, changeTokenState, checkUpliftTokenAvailability) // remove this for non-payment method
  });
  checkUpliftStatus(true);
}

// This is when the user selects a Room.
export function buildOrderInfo(content, travelers, bookingPrice, travelInsurance) {
  const orderInfo = {
    travelers: travelers,
    hotel_reservations: [
      {
        'hotel_name': content ? content.resort : '',
        'number_of_rooms': 1,
        'room_type': content ? content.room : '',
        'check_in': content ? content.checkIn : '',
        'check_out': content ? content.checkOut : '',
        'insurance': travelInsurance > 0 ? [
          {
            'id': '0',
            'types': ['travel'],
            'price': parseInt(travelInsurance + '00', 10)
          }
        ] : []
      }
    ],
    add_ons: [],
    billing_contact: {
      'first_name': content.guests.firstName,
      'last_name': content.guests.lastName,
      'phone': content.phone,
      'email': content.email,
      'date_of_birth': moment(content.guests.dateOfBirth).format('MM/DD/YYYY'),
      'street_address': content.address1,
      'city': content.city,
      'region': content.state,
      'country': content.country,
      'postal_code': content.zipCode
    },
    order_amount: bookingPrice, // equivalent to $999.00 ⚠️ always use cents(integer)
    merchant: content.resortCode,
    merchant_field_1: content.brand,
    merchant_field_2: content.resortCode
  };

  if(content.flights) {
    const flightsObject = content.flights[0];
    const length = flightsObject.leaving.length;
    const origin = flightsObject.leaving[0].departureGateway;
    const destination = flightsObject.leaving[length - 1].arrivalGateway;
    const fligths = {
      'airline_name': content.airline,
      'origin': origin,
      'destination': destination,
      'trip_type': 'roundtrip',
      'itinerary': _upliftCreateItinerariesObject(content.flights),
      'insurance': []
    };

    orderInfo.air_reservations = [fligths];
  }

  return orderInfo;
}

export function payments(summary, bookingPrice, travelInsurance) {

  if(Object.keys(summary).length > 0 && bookingPrice && travelInsurance >= 0) {
    const travelers = _upliftCreateTravelersObject(summary.guests);
    const formatPrice = _upliftMoneyFormat(bookingPrice);
    const orderInfo = buildOrderInfo(summary, travelers, formatPrice, travelInsurance);

    if(window.Uplift) {
      window.Uplift.Payments.load(orderInfo); // add this to the site you need to render.
    }
  }
}

export function tryGetToken() {
  window.Uplift.Payments.getToken();
}

export function upliftJS(isSandals, env) {
  const beachesCode = 'UP-52831797-3';
  const sandalsCode = 'UP-52831797-1';
  let upliftCode = 'UP-52831797-99';

  if(env !== 'TST') {
    upliftCode = isSandals ? sandalsCode : beachesCode;
  }


  (function(u, p, l, i, f, t, o, b, j) {
    u.UpLiftPlatformObject = f; u[f] = u[f] ||
  function() { (u[f].q = u[f].q || []).push(arguments); }, u[f].l = 1 * new Date();
    b = p.createElement(l), j = p.getElementsByTagName(l)[0]; b.async = 1; b.src = i + '?id=' + t;
    j.parentNode.insertBefore(b, j); o = u.location.host.match(/[\w-]+\.\w{2,3}(:\d+)?$/);
    if (o) {o = o[0];} u[f]('create', t, o);
  })(window, document, 'script', 'https://cdn.uplift-platform.com/a/up.js', 'up', upliftCode);
}

export function initUplift(changeTokenState, checkUpliftTokenAvailability, checkUpliftStatus) {
  window.upReady = function() {
    initPayMonthly(changeTokenState, checkUpliftTokenAvailability, checkUpliftStatus);
  };
}

export function initUpliftNonPayment(checkUpliftStatus) {
  window.upReady = function() {
    window.Uplift.Payments.init({
      apiKey: 'WDhFTvgpzv4L2PAbYBubhawCubSbLzQT7u9PkvNG',
      locale: 'en-US',
      currency: 'USD',
      checkout: false,
      channel: 'desktop',
    });
    checkUpliftStatus(true);
  };
}

export function buildOrderInfoNonPayment(content) {
  return {
    travelers: [],
    hotel_reservations: [
      {
        'hotel_name': content ? content.resortName : '',
        'number_of_rooms': 1,
        'room_type': '',
        'check_in': content ? content.checkInDate : '',
        'check_out': content ? content.checkOutDate : '',
        'insurance': []
      }
    ],
    add_ons: [],
    order_amount: 0 // equivalent to $999.00 ⚠️ always use cents(integer)
  };
}

export function nonPaymentUplift(content) {
  const orderInfo = buildOrderInfoNonPayment(content);

  window.Uplift.Payments.load(orderInfo);
}

export function setOrderResponse(bookingId) {

  window.Uplift.Analytics.orderResponse({
    'mode_of_payment': 'pay monthly',
    'order_id': bookingId
  });

  window.Uplift.Payments.confirm(bookingId);
}

export function applyOrderSubmit(summary, bookingPrice, travelInsurance, paymentMethod) {
  if(Object.keys(summary).length > 0 && bookingPrice && travelInsurance >= 0) {
    const travelers = _upliftCreateTravelersObject(summary.guests);
    const formatPrice = _upliftMoneyFormat(bookingPrice);
    const orderInfo = buildOrderInfo(summary, travelers, formatPrice, travelInsurance);
    const data = {
      'mode_of_payment': paymentMethod,
      'payment_options': ['full', 'pay monthly', 'deposit', 'hold', 'other']
    };

    window.Uplift.Analytics.orderSubmit(orderInfo, data);
  }
}



// WEBPACK FOOTER //
// ./js/components/global/Uplift.js